/* tslint:disable */
/* eslint-disable */
export enum EntityOperationEnum {
  Create = 'Create',
  Read = 'Read',
  Update = 'Update',
  Delete = 'Delete',
  Remark = 'Remark',
  Error = 'Error',
  Success = 'Success',
  Email = 'Email'
}
